import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase URL or Anon Key not configured. Check your .env file.');
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '');

// Database types
export interface DbPet {
  id: string;
  user_id: string;
  name: string;
  species: string;
  breed: string | null;
  birth_date: string | null;
  weight_kg: number | null;
  photo_url: string | null;
  notes: string | null;
  is_active: boolean;
  created_at: string;
}

export interface DbFeeding {
  id: string;
  pet_id: string;
  user_id: string;
  feeding_type: string;
  food_type: string;
  food_name: string | null;
  brand: string | null;
  amount_grams: number | null;
  calories: number | null;
  notes: string | null;
  fed_at: string;
  created_at: string;
  // Joined field
  pets?: { name: string };
}

export interface DbWeightRecord {
  id: string;
  pet_id: string;
  user_id: string;
  weight_kg: number;
  measured_at: string;
  notes: string | null;
  created_at: string;
}

export interface DbUserPreferences {
  user_id: string;
  theme_id: string;
  notification_enabled: boolean;
  daily_reminder_time: string;
  weight_unit: string;
  language: string;
  dashboard_widgets_v2: unknown | null;
  widget_order: string[] | null;
  auto_compact_grid: boolean;
  created_at: string;
}
